import { Loader2 } from "lucide-react";
import type { Invoice } from "@/lib/invoice.api";
import type { InvoiceViewMode } from "../invoice.constants";
import { InvoiceGrid } from "./InvoiceGrid";
import { InvoicesTable } from "./InvoicesTable";

interface InvoicesContentProps {
  invoices: Invoice[];
  viewMode: InvoiceViewMode;
  isLoading: boolean;
  onSelect: (invoice: Invoice) => void;
}

export function InvoicesContent({ invoices, viewMode, isLoading, onSelect }: InvoicesContentProps) {
  if (isLoading) {
    return <Loader2 className="animate-spin text-subtle" size={18} />;
  }

  if (viewMode === "grid") {
    return <InvoiceGrid invoices={invoices} onSelect={onSelect} />;
  }

  return <InvoicesTable invoices={invoices} onSelect={onSelect} />;
}
